export function bucketFromNow(timeRange) {
    const now = Date.now();
    const ranges = {
        "30m": now - 30 * 60000,
        "1h": now - 3600000,
        "6h": now - 6 * 3600000,
        "24h": now - 24 * 3600000,
        "7d": now - 7 * 86400000,
        "30d": now - 30 * 86400000,
        "90d": now - 90 * 86400000,
    };
    const fromMs = ranges[timeRange] || ranges["24h"];
    return { from: new Date(fromMs), to: new Date(now) };
}

export function formatTimestamp(ts, granularity) {
    const d = new Date(ts);
    if (granularity === "hour" || granularity === "minute" || granularity === "second") {
        return d.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });
    }
    return d.toLocaleDateString([], { month: "short", day: "numeric" });
}
